import Game from './src/modules/Game';

document.addEventListener('DOMContentLoaded', function() {

  const game = new Game({
    spritesheet: 'sprites.json'
  });
  game.load().catch((e) => {
    console.error('[duckhunt] failed to start — renderer or asset load', e);
    document.body.insertAdjacentHTML('beforeend',
      '<p style="color:#fff;font:16px monospace;text-align:center;margin-top:40vh">' +
      'failed to start — check the console</p>');
  });

  // Console/demo API: duckhunt.zap('b2', 'somebody.xyz')
  window.duckhunt = {
    zap: (cell, handle) => game.zapFromConsole(cell, handle),
    join: (handle) => game.stubJoin(handle),
    game
  };

}, false);
